
import { SubNavItem } from './NavPrimitives';
import {
  BuildOfferIcon,
  CloseTransferIcon,
  ConditionScoreIcon,
  ContextScoreIcon,
  HOAIcon,
  HomeHubIcon,
  InboxIcon,
  ManageEscrowIcon,
  NegotiateIcon,
  RepairPlannerIcon,
  SellerDisclosuresIcon,
  SummaryIcon,
  TasksIcon,
} from './SidebarIcons';

import { Icon } from '@/components/common/Icon';

export const dueDiligenceItems: SubNavItem[] = [
  { path: '/dashboard/summary', label: 'Overview', icon: <SummaryIcon /> },
  { path: '/dashboard/condition-score', label: 'The Home', icon: <ConditionScoreIcon /> },
  { path: '/dashboard/context-score', label: 'The Area', icon: <ContextScoreIcon /> },
  { path: '/dashboard/repair-planner', label: 'Repair Planner', icon: <RepairPlannerIcon /> },
  {
    path: '/dashboard/market-insights',
    label: 'Market Insights',
    icon: <Icon name="perform" size={15} />,
    // TEMPORARY: lock glyph only (the page still opens); remove once Market Insights is ready to show
    lock: true,
  },
];

// Only shown for HOA-governed properties — spliced in by useDueDiligenceItems,
// not part of the static array above, since most properties have no HOA.
export const hoaDueDiligenceItem: SubNavItem = {
  path: '/dashboard/hoa',
  label: 'HOA',
  icon: <HOAIcon />,
};

// Only shown once a seller disclosure packet has been uploaded and processed —
// spliced in by useDueDiligenceNavItems, same pattern as the HOA tab.
export const sellerDisclosuresDueDiligenceItem: SubNavItem = {
  path: '/dashboard/seller-disclosures',
  label: 'Seller Disclosures',
  icon: <SellerDisclosuresIcon />,
};

export const transactionItems: SubNavItem[] = [
  {
    path: '/dashboard/build-offer',
    label: 'Build Offer',
    icon: <BuildOfferIcon />,
    disabled: true,
    lock: true,
  },
  {
    path: '/dashboard/negotiate',
    label: 'Negotiate',
    icon: <NegotiateIcon />,
    disabled: true,
    lock: true,
  },
  {
    path: '/dashboard/escrow',
    label: 'Manage Escrow',
    icon: <ManageEscrowIcon />,
    disabled: true,
    lock: true,
  },
  {
    path: '/dashboard/close',
    label: 'Close & Transfer',
    icon: <CloseTransferIcon />,
    disabled: true,
    lock: true,
  },
];

export const homeownerItems: SubNavItem[] = [
  {
    path: '/dashboard/home-hub',
    label: 'Home HQ',
    icon: <HomeHubIcon />,
  },
];

export const selfServeHomeownerItems: SubNavItem[] = [
  {
    path: '/dashboard/home-hub',
    label: 'Overview',
    icon: <HomeHubIcon />,
  },
  {
    path: '/dashboard/home-hub/repair-plan',
    label: 'Repair Plan',
    icon: <RepairPlannerIcon />,
  },
  {
    path: '/dashboard/home-hub/records',
    label: 'Records',
    icon: <Icon name="book" size={15} />,
  },
  {
    path: '/dashboard/home-hub/directory',
    label: 'Directory',
    icon: <Icon name="contact" size={15} />,
  },
  {
    path: '/dashboard/home-hub/calendar',
    label: 'Calendar',
    icon: <Icon name="calendar" size={15} />,
  },
];

export const toolsItems: SubNavItem[] = [
  {
    path: '/dashboard/calculators',
    label: 'Calculators',
    icon: <Icon name="calc" size={15} />,
  },
];

export const dataItems: SubNavItem[] = [
  { path: '/admin/logic', label: 'Logic', icon: <Icon name="layers" size={15} /> },
  {
    path: '/admin/infracosts',
    label: 'Infra',
    icon: <Icon name="dollar" size={15} />,
  },
  { path: '/admin/kpis', label: 'KPIs', icon: <Icon name="chart" size={15} /> },
  {
    path: '/admin/acquisitions',
    label: 'Performance',
    icon: <Icon name="funnel" size={15} />,
  },
];

export const adminItems: SubNavItem[] = [
  { path: '/admin/users', label: 'Users', icon: <Icon name="team" size={15} /> },
  {
    path: '/admin/properties',
    label: 'Properties',
    icon: <Icon name="home" size={15} />,
  },
  {
    path: '/admin/relationships',
    label: 'Relationships',
    icon: <Icon name="connect" size={15} />,
  },
];

// the advisor's Today screen: the day's deadlines, inbox, pipeline and properties at a glance (pages/dashboard/TodayView)
export const todayItem: SubNavItem = {
  path: '/dashboard/today',
  label: 'Today',
  icon: <Icon name="today" size={15} />,
};

export const clientsItem: SubNavItem = {
  path: '/dashboard/clients',
  label: 'Clients & Deals',
  icon: <Icon name="team" size={15} />,
};

export const propertiesItem: SubNavItem = {
  path: '/dashboard/properties',
  label: 'Properties',
  icon: <Icon name="home" size={15} />,
};

export const tasksDrawerItem = (onClick: () => void): SubNavItem => ({
  path: 'tasks-drawer',
  label: 'Tasks',
  icon: <TasksIcon size={15} />,
  onClick,
});

export const messagesItem = (onClick: () => void, badge?: number): SubNavItem => ({
  path: 'messages-drawer',
  label: 'Messages',
  icon: <InboxIcon size={15} />,
  badge,
  onClick,
});
